import React, { useMemo } from 'react'

import { useTranslation } from 'react-i18next'
import { useFetcher } from 'react-router-dom'

import Button from '@components/shared/Button'
import Score from '@models/Score'
import { useSelection } from '@providers/SelectionProvider'

interface Props {
  collectionId: number
  collectionType?: string | null
}

const RemoveFromCollectionButton: React.FC<Props> = ({ collectionId, collectionType }: Props) => {
  const { t } = useTranslation()

  const fetcher = useFetcher()
  const { selectedItems } = useSelection<Score>()
  const scoreIds = useMemo(() => selectedItems.map((item) => item.external_id), [selectedItems])

  const isSubmitting = ['submitting', 'loading'].includes(fetcher.state)
  return (
    <fetcher.Form method="post" action="/home/removeFromCollection">
      <Button
        variant="outline"
        value={scoreIds.join(',')}
        name="scoreIds"
        size="sm"
        className="font-medium ml-2.5"
        type="submit"
        disabled={!selectedItems.length || isSubmitting}>
        {t('action.remove')}
      </Button>
      <input type="hidden" name="collectionId" value={collectionId} />
      {collectionType && <input type="hidden" name="collectionType" value={collectionType} />}
    </fetcher.Form>
  )
}

export default RemoveFromCollectionButton
